import { useEffect, useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { api } from "@/api";
import Shell from "@/components/Shell";
import { exhibitorNav } from "./ExhibitorDashboard";
import { Spinner, Overline } from "@/components/Brand";
import { toast } from "sonner";
import { Download, Copy } from "lucide-react";

export default function ExhibitorQR() {
  const [p, setP] = useState(null);
  useEffect(() => { api.get("/exhibitor/profile").then(({ data }) => setP(data)); }, []);
  if (!p) return <Shell nav={exhibitorNav}><Spinner /></Shell>;

  const shareUrl = `${window.location.origin}/s/${p.qr_code}`;

  const download = () => {
    const canvas = document.querySelector("#stall-qr canvas");
    if (!canvas) return;
    const link = document.createElement("a");
    link.download = `${p.name}-QR.png`;
    link.href = canvas.toDataURL();
    link.click();
  };

  return (
    <Shell nav={exhibitorNav}>
      <Overline>Stall Check-In</Overline>
      <h1 className="font-display text-3xl gold-text mt-2">Your QR Code</h1>
      <p className="text-slate-400 text-sm mt-1">Display this at your stall. Visitors scan it to check in & view catalogues.</p>

      <div className="glass rounded-3xl p-8 mt-6 text-center max-w-sm mx-auto gold-glow" data-testid="exhibitor-qr-card">
        <div id="stall-qr" className="bg-white p-5 rounded-2xl inline-block">
          <QRCodeCanvas value={p.qr_code} size={200} level="H" includeMargin={false} fgColor="#0A221C" />
        </div>
        <h3 className="font-serif-head text-2xl text-slate-100 mt-5">{p.name}</h3>
        <p className="text-slate-400 text-sm">{p.hall} · {p.booth}</p>
        <div className="mt-3 inline-flex items-center gap-2 text-amber-300 font-mono-j text-sm bg-amber-500/10 px-3 py-1.5 rounded-lg" data-testid="qr-code-text">
          {p.qr_code}
          <Copy size={14} className="cursor-pointer" onClick={() => { navigator.clipboard?.writeText(p.qr_code); toast.success("Code copied"); }} />
        </div>
        <button onClick={download} className="w-full btn-gold py-3 rounded-xl mt-6 flex items-center justify-center gap-2" data-testid="qr-download"><Download size={16} /> Download QR</button>
      </div>
    </Shell>
  );
}
